// src/features/fourlink-config/components/shared/CommentModal.jsx

import React from 'react';

export const CommentModal = ({ isOpen, onClose, comment, onChange, onSave, targetLabel }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={onClose}
    >
      <div className="w-full max-w-lg rounded-xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <h3 className="text-lg font-semibold text-gray-800">Anadir comentario: {targetLabel || 'Elemento'}</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-2xl leading-none text-gray-500 hover:text-gray-700"
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
        <div className="space-y-4 px-6 py-4">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700" htmlFor="comment-input">
              Comentario
            </label>
            <textarea
              id="comment-input"
              value={comment}
              onChange={(e) => onChange(e.target.value)}
              placeholder="Escribe aqui tu comentario"
              className="w-full min-h-[120px] rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-transparent focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 border-t border-gray-200 px-6 py-4">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-200"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onSave}
            className="rounded-lg px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
            style={{ backgroundColor: '#3182ce' }}
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};
